import Image from "next/image";

export default function DropdownScrollDown() {
  return (
    <div className="absolute bottom-10 left-1/2 transform -translate-y-2 p-1 bg-white rounded-[26px] shadow ">
      <Image
        loader={({ src }) => src}
        sizes="30px"
        src="/scroll-down.webp"
        unoptimized
        loading="lazy"
        alt="Scroll Down Animated GIF"
        title="Scroll Down Animated GIF"
        width={30}
        height={30}
        style={{
          maxWidth: "100%",
        }}
      />
    </div>
  );
}
